import { DateTime } from 'luxon';
import { formatCentToEuro, formatDate, getHours, getHoursFromSeconds, padZero } from '@/utlitities/helper';
import { Vue } from 'vue-property-decorator';
import numeral from 'numeral';
import { UserStore } from '@/store/user-module';
import { RateRuleEnum } from '@/services/api/nswag/stapiclient_generated';
import { vm } from '@/main';

Vue.filter('formatDateDayNumber', (value: any) => {
  if (value) {
    const dt = DateTime.fromISO(value);
    return dt.toFormat('dd');
  }
});

Vue.filter('formatDate', (value: any, formatString: string = '') => {
  return formatDate(value, formatString);
});

Vue.filter('formatDateUtcToLocal', (value: any, formatString: string = '') => {
  if (value) {
    let dt = value;
    if (!DateTime.isDateTime(value)) {
      dt = DateTime.fromISO(value, { zone: 'utc' });
      dt = dt.toLocal();
    }

    if (formatString) {
      return dt.toFormat(formatString);
    }

    return dt.toFormat(UserStore.userSettings.datePattern ?? 'dd.MM.yyyy');
  }
});

Vue.filter('formatCentToEuro', (value: number) => {
  return formatCentToEuro(value);
});

Vue.filter('formatMonth', (value: any) => {
  if (value) {
    const dt = DateTime.fromISO(value);
    return dt.toFormat('MM.yyyy');
  }
});

Vue.filter('formatQuarter', (value: any) => {
  if (value) {
    const dt = DateTime.fromISO(value);
    return 'Q' + dt.toFormat('q yyyy');
  }
});

Vue.filter('formatMonthName', (value: any) => {
  if (value) {
    const dt = DateTime.fromISO(value);
    return dt.toFormat('MMM');
  }
});

Vue.filter('formatNumber', (value: any, format: string = '') => {
  if (!format) {
    format = '0,0.00';
  }

  return numeral(value).format(format); // displaying other groupings/separators is possible, look at the docs
});

Vue.filter('durationHours', (value: number) => {
  return getHours(value);
});

Vue.filter('durationHoursWithSign', (value: number) => {
  return getHours(value, true);
});

Vue.filter('durationHoursWithSignAndPlusMinus', (value: number) => {
  return getHours(value, true, true);
});

Vue.filter('durationHoursFromSeconds', (value: number) => {
  return getHoursFromSeconds(value);
});

Vue.filter('amountCurrency', (value: number, currency: string = '') => {
  return numeral(value).format('0,0.00') + ' ' + (currency || UserStore.userSettings.currency);
});

Vue.filter('padZero', (value: number) => {
  return padZero(value);
});

Vue.filter('rateRuleSourceText', (value: RateRuleEnum) => {
  switch (value) {
    case RateRuleEnum.Global:
      return vm.$t('Globaler Stundensatz');
    case RateRuleEnum.Customer:
      return vm.$t('Stundensatz des Kunden');
    case RateRuleEnum.Project:
      return vm.$t('Stundensatz des Projekts');
    case RateRuleEnum.ProjectTask:
      return vm.$t('Stundensatz der Projektleistung');
    case RateRuleEnum.GlobalProjectTask:
      return vm.$t('Stundensatz der Leistung');
    case RateRuleEnum.AppUser:
      return vm.$t('Stundensatz des Mitarbeiters');
    default:
      return '';
  }
});

Vue.filter('toMonthName', (value: number) => {
  const arr = ['Januar', 'Februar', 'März', 'April', 'Mai', 'Juni', 'Juli', 'August', 'September', 'Oktober', 'November', 'Dezember'];
  return vm.$t(arr[value - 1]);
});
